import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface DividerProps extends React.HTMLAttributes<HTMLHRElement> {
	className?: string;
	fullWidth?: boolean;
}

export function Divider({ className, fullWidth, ...rest }: DividerProps) {
	return (
		<hr
			className={cssClasses(css.divider, fullWidth && css.fullWidth, className)}
			{...rest}
		/>
	);
}
